<div class="account-section">
  <div class="my-section-box">
    @if (true) {
      <form [formGroup]="airdiskFleetInfoForm">
        <div class="my-section-box__headline">
        {{ 'common.value_calculator_flit_info_title' | cxTranslate }}</div>
        <div class="my-section-box csaDowntime" id="fleetInfo">
          <div class="my-section-box-inner fleet-info-inner">
            <div class="row fleet-info-block">
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 px-0">
                <label class="form-label" for="fleetSize">
                {{ 'common.airDiscBrake_value_calculator_fleetSize' | cxTranslate }}</label>
                <div class="col-12 px-0 row">
                  <div class="col-8 col-xs-8 col-sm-6 pr-0">
                    <input type="text" formControlName="fleetSize" />
                    @if (form.fleetSize.invalid && (form.fleetSize.dirty || form.fleetSize.touched)) {
                      <span class="text-danger-show"
                        >
                      {{'common.form_field_required'|cxTranslate}}</span>
                    }
                  </div>
                  <div class="col-4 col-xs-4 col-sm-5 EndaTooltip">
                    @if (isTractor) {
                      <span>
                        {{ 'common.airdisc_value_calculator_tractors_text' | cxTranslate }}
                      </span>
                    }
                    @if (!isTractor) {
                      <span>
                        {{ 'common.value_calculator_trailers_text' | cxTranslate }}
                      </span>
                    }
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 px-0">
                <label class="form-label" for="totalNumberOfAxlesPerUnit">
                {{ 'common.airDiscBrake_value_calculator_totalNumberOfAxlesPerUnit' | cxTranslate }}*</label>
                <div class="col-12 px-0 row">
                  <div class="col-8 col-xs-8 col-sm-6 pr-0">
                    <input type="text" formControlName="totalNumberOfAxlesPerUnit" />
                    @if (form.totalNumberOfAxlesPerUnit.invalid && (form.totalNumberOfAxlesPerUnit.dirty || form.totalNumberOfAxlesPerUnit.touched)) {
                      <span class="text-danger-show"
                        >
                      {{'common.form_field_required'|cxTranslate}}</span>
                    }
                  </div>
                  <div class="col-4 col-xs-4 col-sm-5 EndaTooltip">
                    {{ 'common.value_calculator_fleet_axles_unit' | cxTranslate }}
                    <mat-dialog-actions>
                      <span (click)="airdiskService.openTootlip(
                              'common.airDiscBrake_value_calculator_totalNumberOfAxlesPerUnit',
                               'common.airDiscBrake_value_calculator_totalNumberOfAxlesPerUnit_tooltip')"
                        class="btn-link">
                        <img src="/icons/question_dark_kb.svg" alt="Air Disc fleet-info Service">
                      </span>
                    </mat-dialog-actions>
                  </div>
                </div>
              </div>
            </div>
            <div class="row fleet-info-block">
              <!-- For Tractor -->
              @if (isTractor) {
                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 px-0">
                  <label class="form-label" for="tractorTradeInCycle">
                    {{'common.airDiscBrake_value_calculator_tractorTradeInCycle' | cxTranslate }}
                  </label>
                  <div class="col-12 px-0 row">
                    <div class="col-8 col-xs-8 col-sm-6 pr-0">
                      <input type="text" formControlName="tractorTradeInCycle" />
                      @if (form.tractorTradeInCycle.invalid && (form.tractorTradeInCycle.dirty || form.tractorTradeInCycle.touched)) {
                        <span class="text-danger-show"
                          >
                          <span>{{'common.form_field_required'|cxTranslate}}</span>
                        </span>
                      }
                    </div>
                    <div class="col-4 col-xs-4 col-sm-5 EndaTooltip">
                      {{ 'common.value_calculator_year_text' | cxTranslate }}
                    </div>
                  </div>
                </div>
              }
              <!-- For Trailer -->
              @if (!isTractor) {
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 px-0">
                  <label class="form-label" for="trailerTradeInCycle">
                    {{'common.value_calculator_trailerTradeInCycle' | cxTranslate }}
                  </label>
                  <div class="col-12 px-0 row">
                    <div class="col-xs-8 col-sm-6 pr-0">
                      <input type="text" formControlName="trailerTradeInCycle" />
                      @if (form.trailerTradeInCycle.invalid && (form.trailerTradeInCycle.dirty || form.trailerTradeInCycle.touched)) {
                        <span class="text-danger-show"
                          >
                          <span>{{'common.form_field_required'|cxTranslate}}</span>
                        </span>
                      }
                    </div>
                    <div class="col-xs-4 col-sm-5 EndaTooltip">
                      {{ 'common.value_calculator_year_text' | cxTranslate }}
                    </div>
                  </div>
                </div>
              }
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 px-0">
                <label class="form-label" for="averageAnnualUnitMilage">
                  {{ 'common.airDiscBrake_value_calculator_averageAnnualUnitMileage' | cxTranslate }}
                </label>
                <div class="col-12 px-0 row">
                  <div class="col-8 col-xs-8 col-sm-6 pr-0">
                    <input type="text" formControlName="averageAnnualUnitMilage" />
                    @if (form.averageAnnualUnitMilage.invalid && (form.averageAnnualUnitMilage.dirty || form.averageAnnualUnitMilage.touched)) {
                      <span class="text-danger-show"
                        >
                      {{'common.form_field_required'|cxTranslate}}</span>
                    }
                  </div>
                  <div class="col-4 col-xs-4 col-sm-5 EndaTooltip">
                    {{ 'common.value_calculator_fleet_miles' | cxTranslate }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row fleet-info-block">
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 px-0">
                <label class="form-label" for="drumToShoeReplacementFrequency">
                {{ 'common.airDiscBrake_value_calculator_drumtoshorereplacementFrequency' | cxTranslate }}*</label>
                <div class="col-12 px-0 row">
                  <div class="col-8 col-xs-8 col-sm-6 pr-0 min-wid">
                    <select class="form-control" formControlName="drumToShoeReplacementFrequency">
                      @for (x of adbDropDownData; track x) {
                        <option [value]="x.code">{{ x.name |cxTranslate}}</option>
                      }
                    </select>
                    @if (form.drumToShoeReplacementFrequency.invalid && (form.drumToShoeReplacementFrequency.dirty || form.drumToShoeReplacementFrequency.touched)) {
                      <span class="text-danger-show"
                        >
                      {{'common.form_field_required'|cxTranslate}}</span>
                    }
                  </div>
                  <div class="col-4 col-xs-4 col-sm-5 EndaTooltip max-wid">
                    <mat-dialog-actions>
                      <span (click)="airdiskService.openTootlip(
                              'common.airDiscBrake_value_calculator_drumtoshorereplacementFrequency',
                               'common.airDiscBrake_value_calculator_drumtoshorereplacementFrequency_tooltip')"
                        class="btn-link">
                        <img src="/icons/question_dark_kb.svg" alt="Air Disc fleet-info Service">
                      </span>
                    </mat-dialog-actions>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 px-0">
                <label class="form-label" for="adbUpCharge">
                  {{ 'common.airDiscBrake_value_calculator_adbupcharge' | cxTranslate }}*
                </label>
                <div class="col-12 px-0 row">
                  <div class="col-8 col-xs-8 col-sm-6 pr-0">
                    <input type="text" formControlName="adbUpCharge" appNumberFormat />
                    @if (form.adbUpCharge.invalid && (form.adbUpCharge.dirty || form.adbUpCharge.touched)) {
                      <span class="text-danger-show"
                        >
                      {{'common.form_field_required'|cxTranslate}}</span>
                    }
                  </div>
                  <div class="col-4 col-xs-4 col-sm-5 EndaTooltip">
                    {{ 'common.text_smartire_usd' | cxTranslate }}
                    <mat-dialog-actions>
                      <span (click)="airdiskService.openTootlip(
                                'common.airDiscBrake_value_calculator_adbupcharge',
                                'common.airDiscBrake_value_calculator_adbupcharge_tootlip')" class="btn-link">
                        <img src="/icons/question_dark_kb.svg" alt="Air Disc fleet-info Service">
                      </span>
                    </mat-dialog-actions>
                  </div>
                </div>
              </div>
            </div>
            <div class="row fleet-info-block">
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 px-0">
                <label class="form-label" for="fleetMaintenanceLaborRate">
                  {{ 'common.airDiscBrake_value_calculator_fleetMaintenanceLaborRate' | cxTranslate }}*
                </label>
                <div class="col-12 px-0 row">
                  <div class="col-8 col-xs-8 col-sm-6 pr-0">
                    <input type="text" formControlName="fleetMaintenanceLaborRate" appNumberFormat />
                    @if (form.fleetMaintenanceLaborRate.invalid && (form.fleetMaintenanceLaborRate.dirty || form.fleetMaintenanceLaborRate.touched)) {
                      <span class="text-danger-show"
                        >
                      {{'common.form_field_required'|cxTranslate}}</span>
                    }
                  </div>
                  <div class="col-4 col-xs-4 col-sm-5 EndaTooltip">
                    {{ 'common.airDiscBrake_value_calculator_usd_hour' | cxTranslate }}
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 px-0">
                <label class="form-label" for="adbResidualValueAtTradeIn">
                  {{ 'common.airDiscBrake_value_calculator_adbResidualValueatTradeIn' | cxTranslate }}*
                </label>
                <div class="col-12 px-0 row">
                  <div class="col-8 col-xs-8 col-sm-6 pr-0">
                    <input type="text" formControlName="adbResidualValueAtTradeIn" appNumberFormat />
                    @if (form.adbResidualValueAtTradeIn.invalid && (form.adbResidualValueAtTradeIn.dirty || form.adbResidualValueAtTradeIn.touched)) {
                      <span class="text-danger-show"
                        >
                      {{'common.form_field_required'|cxTranslate}}</span>
                    }
                  </div>
                  <div class="col-4 col-xs-4 col-sm-5 EndaTooltip">
                    {{ 'common.text_smartire_usd' | cxTranslate }}*
                    <mat-dialog-actions>
                      <span (click)="airdiskService.openTootlip(
                              'common.airDiscBrake_value_calculator_adbResidualValueatTradeIn',
                               'common.airDiscBrake_value_calculator_popup_tradeIn')" class="btn-link">
                        <img src="/icons/question_dark_kb.svg" alt="Air Disc fleet-info Service">
                      </span>
                    </mat-dialog-actions>
                  </div>
                </div>
              </div>
            </div>
            <div class="row fleet-info-block">
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 px-0">
                <label class="form-label" for="fleetDownTimeRate">
                {{ 'common.airDiscBrake_value_calculator_fleetDowntimeRate' | cxTranslate }}</label>
                <div class="col-12 px-0 row">
                  <div class="col-8 col-xs-8 col-sm-6 pr-0">
                    <input type="text" formControlName="fleetDownTimeRate" appNumberFormat />
                    @if (form.fleetDownTimeRate.invalid && (form.fleetDownTimeRate.dirty || form.fleetDownTimeRate.touched)) {
                      <span class="text-danger-show"
                        >
                      {{'common.form_field_required'|cxTranslate}}</span>
                    }
                  </div>
                  <div class="col-4 col-xs-4 col-sm-5 EndaTooltip">
                    {{ 'common.value_calculator_usdDay_text' | cxTranslate }}
                    <mat-dialog-actions>
                      <span (click)="airdiskService.openTootlip(
                              'common.airDiscBrake_value_calculator_fleetDowntimeRate',
                               'common.airDiscBrake_value_calculator_popup_fleet')" class="btn-link">
                        <img src="/icons/question_dark_kb.svg" alt="Air Disc fleet-info Service">
                      </span>
                    </mat-dialog-actions>
                  </div>
                </div>
              </div>
            </div>
            <div class="airdisk-button-block">
              <button type="button" class="btn btn-primary endaSureBack visitorInfoNext yellow-btn"
                (click)="endaSureBack()"><img src="/icons/link-right-white.svg" class="right-arrow"
                alt="Air Disc fleet-info Service Back">
              {{ 'common.value_calculator_back_button' | cxTranslate }}</button>
              <button type="button" class="btn btn-primary endaSureNxt visitorInfoNext yellow-btn"
                (click)="endaSureNxt()">{{ 'common.value_calculator_next_button' | cxTranslate }}
                <img src="/icons/link-right-white.svg" class="right-arrow"
                alt="Air Disc fleet-info Service Next"></button>
              </div>
            </div>
          </div>
        </form>
      }
    </div>
  </div>